import { useState, useEffect, useRef } from 'react';
const useTimer = (targetTime, subtractOneHour = true) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const targetTimeRef = useRef(targetTime);
  useEffect(() => {
    targetTimeRef.current = targetTime;
    const now = new Date();
    const offset = subtractOneHour ? (1000 * 60 * 60) : 0;
    const adjustedTargetTime = targetTimeRef.current ? (targetTimeRef.current - offset) : null;
    const distance = adjustedTargetTime !== null ? (adjustedTargetTime - now.getTime()) : -1;
    if (distance < 0) {
      setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    } else {
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setTimeLeft({ days, hours, minutes, seconds });
    }
  }, [targetTime, subtractOneHour]);
  useEffect(() => {
    // console.log("Timer effect initialized");
    const updateTimer = () => {
      const now = new Date();
      const offset = subtractOneHour ? (1000 * 60 * 60) : 0; // :arrow_left: control subtraction
      const adjustedTargetTime = targetTimeRef.current ? (targetTimeRef.current - offset) : null;
      const distance = adjustedTargetTime !== null ? (adjustedTargetTime - now.getTime()) : -1;
      if (distance < 0) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        });
        return;
      }
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setTimeLeft({
        days,
        hours,
        minutes,
        seconds,
      });
      // console.log("Updated time left:", { days, hours, minutes, seconds });
    };
    const intervalId = setInterval(updateTimer, 1000);
    return () => {
      // console.log("Timer effect cleaned up");
      clearInterval(intervalId);
    };
  }, [subtractOneHour]);
  return timeLeft;
};
export default useTimer;